const envApiUriMapping = {
  dev: 'http://localhost:5000',
  // This is the host the core API's own HTTPRoute declares on Mapal DEV (msw-inp-gitops,
  // dev/gwc/api/msw-inp-core-api). The placeholder 'api.inpulse.dev.mapal-os.com' used until now
  // is not routed at all — the gateway answers 404, route not found.
  //
  // The core API is NOT serving on Mapal DEV yet: dev/gwc/api is not registered in the permanent
  // Argo CD ApplicationSet, and the HTTPRoute that answers today (503, no healthy upstream) comes
  // from a temporary nginx stack that only validates secrets and will be torn down. So a
  // 'mapal-dev' build serves the UI and reaches the agent/invoice-control APIs, but core API
  // calls and Cryptr login will fail until the API is deployed for real. This host is still the
  // right target: it is where the API will answer. Mapal work items 49702 and 53026.
  mapalDev: 'https://core-api.inpulse.dev.mapal-os.com',
  // Mapal PRE, mirroring mapalDev. The PRE APIs are deployed by Mapal work item 55111; until
  // they are, a 'mapal-pre' build serves the UI but its API calls fail. Mapal work item 55114.
  mapalPre: 'https://core-api.inpulse.pre.mapal-os.com',
  test: 'https://core-api.inpulse.dev.mapal-os.com',
  demo: 'https://api-demo.deepsight.io',
  staging: 'https://api-staging.inpulse.ai',
  prod: 'https://api.deepsight.io',
};

const envAppUriMapping = {
  dev: 'http://localhost:4000/',
  mapalDev: 'https://app.inpulse.dev.mapal-os.com/',
  mapalPre: 'https://app.inpulse.pre.mapal-os.com/',
  test: 'https://app.inpulse.dev.mapal-os.com/',
  staging: 'https://app-staging.inpulse.ai/',
  prod: 'https://app.inpulse.ai/',
};

const envInpulseAgentApiUriMapping = {
  dev: 'http://localhost:8000',
  mapalDev: 'https://agent-api.inpulse.dev.mapal-os.com',
  mapalPre: 'https://agent-api.inpulse.pre.mapal-os.com',
  test: 'https://agent-api.inpulse.dev.mapal-os.com',
  demo: 'https://agent-api.inpulse.pre.mapal-os.com',
  staging: 'https://agent-api.inpulse.pre.mapal-os.com',
  prod: 'https://agent-api.data.inpulse.ai',
};

const envInpulseInvoiceControlApiUriMapping = {
  dev: 'http://localhost:8080',
  mapalDev: 'https://invoice-control-api.inpulse.dev.mapal-os.com',
  mapalPre: 'https://invoice-control-api.inpulse.pre.mapal-os.com',
  test: 'https://invoice-control-api.inpulse.dev.mapal-os.com',
  demo: 'https://invoice-control-api.inpulse.pre.mapal-os.com',
  staging: 'https://invoice-control-api.inpulse.pre.mapal-os.com',
  prod: 'https://invoice-control-api.data.inpulse.ai',
};

const cryptrEnvMapping = {
  dev: {
    REACT_APP_CRYPTR_AUDIENCE: 'http://localhost:4000',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'http://localhost:4000/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  // Reuses the shared non-production Cryptr client. The redirect URI below must be allow-listed
  // on that client before login works from the Mapal DEV domain.
  mapalDev: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app.inpulse.dev.mapal-os.com',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app.inpulse.dev.mapal-os.com/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  // Same shared non-production client; the PRE redirect URI must be allow-listed on it too.
  mapalPre: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app.inpulse.pre.mapal-os.com',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app.inpulse.pre.mapal-os.com/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  test: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app-test.inpulse.ai',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app-test.inpulse.ai/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  staging: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app-staging.inpulse.ai',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: '2266081f-17a6-42ed-a1c7-166a89878308',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app-staging.inpulse.ai/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
  prod: {
    REACT_APP_CRYPTR_AUDIENCE: 'https://app.inpulse.ai',
    REACT_APP_CRYPTR_BASE_URL: 'https://inpulse.authent.me',
    REACT_APP_CRYPTR_CLIENT_ID: 'de193f1d-d70e-443f-9c19-1c99eab6d72d',
    REACT_APP_CRYPTR_DEFAULT_REDIRECT_URI: 'https://app.inpulse.ai/login',
    REACT_APP_CRYPTR_TENANT_DOMAIN: 'inpulse',
  },
};

/**
 * MOS (Mapal OS) OIDC SPA client settings.
 * Override per env via REACT_APP_MOS_* when registering the InPulse SPA client in MOS.
 * Login with MOS stays hidden until issuer + clientId are both set.
 * Default scope includes offline_access so MOS can issue a refresh_token.
 */
export const MOS_DEFAULT_SCOPE = 'openid profile offline_access';

/**
 * MOS admin API host consumed by the MOS operator/product switchers
 * (GET /v1/user/operators, PUT /v1/user/default-operator, GET /user/applications).
 * Sandbox host confirmed by the MOS frontend architecture team; prod host TBD, so
 * envs not backed by the MOS sandbox stay empty (switchers are gated on this value being set).
 * The test env (app.inpulse.dev.mapal-os.com) logs in through the MOS sandbox, hence uses it.
 */
const MOS_SANDBOX_ADMIN_API_HOST = 'https://admin-api.sandbox.mapal-os.com';

const mosEnvMapping = {
  dev: {
    issuer: process.env.REACT_APP_MOS_ISSUER || '',
    clientId: process.env.REACT_APP_MOS_CLIENT_ID || '',
    scope: process.env.REACT_APP_MOS_SCOPE || MOS_DEFAULT_SCOPE,
    redirectUri: process.env.REACT_APP_MOS_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MOS_POST_LOGOUT_REDIRECT_URI || '',
    adminApiHost: process.env.REACT_APP_MOS_ADMIN_API_HOST || MOS_SANDBOX_ADMIN_API_HOST,
    debug: process.env.REACT_APP_MOS_DEBUG === 'true',
  },
  mapalDev: {
    issuer: process.env.REACT_APP_MOS_ISSUER || '',
    clientId: process.env.REACT_APP_MOS_CLIENT_ID || '',
    scope: process.env.REACT_APP_MOS_SCOPE || MOS_DEFAULT_SCOPE,
    redirectUri: process.env.REACT_APP_MOS_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MOS_POST_LOGOUT_REDIRECT_URI || '',
    adminApiHost: process.env.REACT_APP_MOS_ADMIN_API_HOST || MOS_SANDBOX_ADMIN_API_HOST,
    debug: process.env.REACT_APP_MOS_DEBUG === 'true',
  },
  mapalPre: {
    issuer: process.env.REACT_APP_MOS_ISSUER || '',
    clientId: process.env.REACT_APP_MOS_CLIENT_ID || '',
    scope: process.env.REACT_APP_MOS_SCOPE || MOS_DEFAULT_SCOPE,
    redirectUri: process.env.REACT_APP_MOS_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MOS_POST_LOGOUT_REDIRECT_URI || '',
    debug: process.env.REACT_APP_MOS_DEBUG === 'true',
  },
  test: {
    issuer: process.env.REACT_APP_MOS_ISSUER || '',
    clientId: process.env.REACT_APP_MOS_CLIENT_ID || '',
    scope: process.env.REACT_APP_MOS_SCOPE || MOS_DEFAULT_SCOPE,
    redirectUri: process.env.REACT_APP_MOS_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MOS_POST_LOGOUT_REDIRECT_URI || '',
    adminApiHost: process.env.REACT_APP_MOS_ADMIN_API_HOST || MOS_SANDBOX_ADMIN_API_HOST,
    debug: false,
  },
  staging: {
    issuer: process.env.REACT_APP_MOS_ISSUER || '',
    clientId: process.env.REACT_APP_MOS_CLIENT_ID || '',
    scope: process.env.REACT_APP_MOS_SCOPE || MOS_DEFAULT_SCOPE,
    redirectUri: process.env.REACT_APP_MOS_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MOS_POST_LOGOUT_REDIRECT_URI || '',
    adminApiHost: process.env.REACT_APP_MOS_ADMIN_API_HOST || '',
    debug: false,
  },
  prod: {
    issuer: process.env.REACT_APP_MOS_ISSUER || '',
    clientId: process.env.REACT_APP_MOS_CLIENT_ID || '',
    scope: process.env.REACT_APP_MOS_SCOPE || MOS_DEFAULT_SCOPE,
    redirectUri: process.env.REACT_APP_MOS_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MOS_POST_LOGOUT_REDIRECT_URI || '',
    adminApiHost: process.env.REACT_APP_MOS_ADMIN_API_HOST || '',
    debug: false,
  },
};

const sleekplanProductId = 844756167;

let baseApiUrl = '';
let baseInpulseAgentApiUrl = '';
let baseInpulseInvoiceControlApiUrl = '';
let baseAppUrl = '';
let cryptrConfig = {};
let mosConfig = {};
let sleekplanConfig = {};

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'production') {
  baseApiUrl = envApiUriMapping['prod'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['prod'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['prod'];
  baseAppUrl = envAppUriMapping['prod'];
  cryptrConfig = cryptrEnvMapping['prod'];
  mosConfig = mosEnvMapping['prod'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'demo') {
  baseApiUrl = envApiUriMapping['demo'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['demo'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['demo'];
  mosConfig = mosEnvMapping['dev'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'staging') {
  baseApiUrl = envApiUriMapping['staging'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['staging'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['staging'];
  baseAppUrl = envAppUriMapping['staging'];
  sleekplanConfig.productId = sleekplanProductId;
  cryptrConfig = cryptrEnvMapping['staging'];
  mosConfig = mosEnvMapping['staging'];
} else if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'test') {
  baseApiUrl = envApiUriMapping['test'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['test'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['test'];
  baseAppUrl = envAppUriMapping['test'];
  cryptrConfig = cryptrEnvMapping['test'];
  mosConfig = mosEnvMapping['test'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_BUILD_ENV === 'mapal-dev'
) {
  baseApiUrl = envApiUriMapping['mapalDev'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['mapalDev'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['mapalDev'];
  baseAppUrl = envAppUriMapping['mapalDev'];
  cryptrConfig = cryptrEnvMapping['mapalDev'];
  mosConfig = mosEnvMapping['mapalDev'];
  sleekplanConfig.productId = sleekplanProductId;
} else if (
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_BUILD_ENV === 'mapal-pre'
) {
  baseApiUrl = envApiUriMapping['mapalPre'];
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['mapalPre'];
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['mapalPre'];
  baseAppUrl = envAppUriMapping['mapalPre'];
  cryptrConfig = cryptrEnvMapping['mapalPre'];
  mosConfig = mosEnvMapping['mapalPre'];
  sleekplanConfig.productId = sleekplanProductId;
} else {
  baseApiUrl = envApiUriMapping['dev']; // Change here to put staging or dev
  baseInpulseAgentApiUrl = envInpulseAgentApiUriMapping['dev']; // Change here to put staging or dev
  baseInpulseInvoiceControlApiUrl = envInpulseInvoiceControlApiUriMapping['dev']; // Change here to put staging or dev
  baseAppUrl = envAppUriMapping['dev']; // Change here to put staging or dev
  cryptrConfig = cryptrEnvMapping['dev'];
  mosConfig = mosEnvMapping['dev'];
  // Uncomment for testing purposes
  // sleekplanConfig.productId = sleekplanProductId;
}

export const config = {
  baseApiUrl,
  baseInpulseAgentApiUrl,
  baseInpulseInvoiceControlApiUrl,
  baseAppUrl,
  isProduction:
    process.env.NODE_ENV === 'production' && process.env.REACT_APP_BUILD_ENV === 'production',
  limitResponseTime:
    process.env.HEALTH_STATUS_LIMIT_RESPONSE_TIME_TO_CONSIDER_SLOW_CONNECTION_IN_MS || 2000,
  cryptr: cryptrConfig,
  mos: mosConfig,
  sleekplan: sleekplanConfig,
};
